// Thao tác SỬA sơ đồ — hàm thuần, trả SoDo MỚI (không đụng bản cũ), KHÔNG kiểm hợp lệ (kiểm bằng kiemSoDo ở so-do.ts / máy chủ).
// Tách riêng, chỉ import kiểu, để trang web Boss dùng được mà không kéo theo thư viện khối/YAML/zod.
import { giaiMaTuKhoa, loiDanhSachTuKhoa, tachTuKhoa, THAM_SO_XOAY } from "./xoay-tu-khoa";
import { loiCauHinhTuKhoa } from "./tu-khoa-nhieu-dong";
import { loiChoGiuaTs, TS_CHO_DEN, TS_CHO_TU } from "./cho-giua-lan"; // (06/10/2026) chờ giữa các lần — tệp thuần, chỉ import kiểu
import { tomTatDangVideo } from "./video-dang"; // (06/10/2026) dòng tóm tắt của bước Đăng video
import { laNenTangVideo } from "./video-kho";
import { loiNgoaiTran } from "./khuyen-nghi-so"; // tệp nhẹ, không import gì (05/10/2026: khoảng số là khuyến nghị, chỉ chặn trần kỹ thuật)
export interface NutSoDo {
  /** Mã nút ỔN ĐỊNH (07/10/2026): /^[a-z0-9]{2,12}$/, không trùng trong sơ đồ; nút mới cấp "n<số>" (số chỉ tăng, không tái dùng mã đã xoá). Id nút CHỈ là khoá của buocCuaNut / kết quả theo nút / bố cục — không vào YAML, không vào hash. */
  id: string;
  thaoTac: string; // mã thao tác trong bản đồ của mạng
  thamSo: Record<string, string>;
  // (03/10/2026) Bước RỦI RO CAO người dùng đặt "Tự động (không cần duyệt)" — chỉ lưu khi true; bước rủi ro thấp bị chuẩn hoá bỏ.
  tuDuyet?: boolean;
  // (07/10/2026, đồ thị nhiều mạng) Mạng của RIÊNG nút này (không có = mạng của sơ đồ) và cờ "Nhường lượt" của ô Nghỉ (so-do/do-thi.ts). Kịch bản MỘT đường không có hai trường này.
  nenTang?: string;
  nhuong?: boolean;
  /** (08/10/2026, đợt A) Ô NGHỈ "Dành cho": mã MỘT ô thuộc đường được gán — trong lúc ô Nghỉ này nghỉ, bộ điều phối CHỈ cho đường đó chạy (do-thi.ts / luot-do-thi.ts). Chuyện điều phối: không vào bundle. */
  danhCho?: string;
  /** (08/10/2026, đợt A) TẦN SUẤT của một bước việc: chỉ lần đầu mỗi ngày / cứ N ngày một lần (theo bot + kịch bản + ô, ngày giờ VN) — ô thành đoạn riêng, tới lượt mà chưa tới hạn thì BỎ QUA sạch. */
  tanSuat?: TanSuatNut;
}
/** Tần suất của một ô việc (đợt A): "dau_ngay" = chỉ lần chạy được đầu tiên mỗi ngày (giờ VN); "n_ngay" = cứ `n` ngày (2..60) một lần. */
export type TanSuatNut = { kieu: "dau_ngay" } | { kieu: "n_ngay"; n: number };
/** Cạnh của đồ thị: nút `tu` chạy xong thì tới nút `den` (mỗi nút vào ≤ 1, ra ≤ 1, không vòng — do-thi.ts kiểm). */
export interface CanhSoDo { tu: string; den: string }
/** Cạnh LẶP ("Quay lại"): xong ô `tu` thì quay về ô `den` (đứng trước, cùng đường) làm thêm `soLan` lần (1..20); `denGio` "HH:MM" giờ VN = thoát vòng sớm khi tới giờ.
 *  (đợt A) `denHetNghi`: lặp tới khi HẾT Ô NGHỈ đã gán cho đường này (bỏ qua soLan) — chỉ dùng cho đường được một ô Nghỉ "Dành cho". */
export interface CanhLap { tu: string; den: string; kieu: "lap"; soLan: number; denGio?: string; denHetNghi?: boolean }
/** Lặp cả sơ đồ: tổng `soVong` vòng (1..20), nghỉ ngẫu nhiên [từ, đến] giây giữa hai vòng (bot rảnh thật); (đợt A) `denGio` "HH:MM" VN = không bắt đầu vòng mới từ giờ đó. */
export interface LapCaSoDo { soVong: number; nghiGiuaVongTuS: number; nghiGiuaVongDenS: number; denGio?: string }
// thuVien: BẢN CHỤP sản phẩm của thư viện Boss (shared/san-pham.ts) — có thì ten/moTa tính lại từ bản chụp; không có = gõ tay như cũ.
export interface HoSoSoDo { ten: string; moTa: string; thuVien?: import("./san-pham").SanPhamSoDo }
export interface SoDo {
  id: string; // [a-z0-9]{6,24} — tên bản chạy được = "kb-<id>"
  ten: string;
  yeuCau: string; // lời mong muốn gốc của người dùng
  nenTang: string; // (đồ thị: mạng MẶC ĐỊNH của sơ đồ — nút không khai nenTang riêng thuộc mạng này)
  hoSo?: HoSoSoDo; // sản phẩm (tuỳ chọn): đưa vào knowledge + AI lọc bài liên quan
  giongDieu?: string;
  camKy?: string[];
  mucTieu?: string;
  gioiHan?: { moiNgay?: number }; // áp thành hạn mức chạy thật/ngày trên bot lúc Chạy thật
  giaDinh?: string[]; // giả định AI ghi (chỉ để hiển thị)
  // GĐ4a: ẢNH CHỤP bài học của Sổ kinh nghiệm lúc tạo/sửa/chạy thử/chạy (máy chủ đặt, không nhận từ client/AI) → knowledge của bản chạy được.
  kinhNghiem?: string[];
  nut: NutSoDo[];
  /** (07/10/2026) ĐỒ THỊ: cạnh nối các nút (thiếu = một chuỗi theo thứ tự `nut`). Có `canh` hoặc có nút khai `nenTang` riêng ⇒ kịch bản dạng ĐỒ THỊ (cha của các kịch bản con ẩn — do-thi.ts). */
  canh?: CanhSoDo[];
  /** (07/10/2026) VÒNG LẶP: cạnh "quay lại" từ ô `tu` về ô `den` ĐỨNG TRƯỚC nó trong cùng đường (do-thi.ts kiểm). Chuyện ĐIỀU PHỐI — không vào bản chạy được (hash con không đổi). */
  lap?: CanhLap[];
  /** (07/10/2026) LẶP CẢ SƠ ĐỒ: mọi đường xong một vòng → nghỉ giữa vòng → chạy lại từ đầu (bộ điều phối luot-do-thi.ts). */
  lapCaSoDo?: LapCaSoDo;
  /** (08/10/2026, đợt B) "Dừng lúc HH:MM" (giờ VN) người dùng nói trong mong muốn — giá trị MẶC ĐỊNH cho "Dừng lúc" của lượt chạy / hẹn giờ (cauHinh.dungLuc). Chuyện điều phối: không vào bundle. */
  dungLuc?: string;
  /** (07/10/2026) Số kế tiếp để cấp mã nút mới: chỉ ghi khi LỚN HƠN 1 + số lớn nhất của mã "n<số>" đang có (tức đã từng xoá mã lớn nhất) — để mã đã xoá không quay lại. */
  nutKe?: number;
}

// ---- MÃ NÚT ỔN ĐỊNH (07/10/2026) ----
export const ID_NUT = /^[a-z0-9]{2,12}$/;
const KE_TOI_DA = 99_999_999; // "n" + 8 chữ số = 9 ký tự ≤ 12
const soKeHopLe = (v: unknown): v is number => typeof v === "number" && Number.isInteger(v) && v >= 1 && v <= KE_TOI_DA;
/** Số lớn nhất của các mã dạng "n<số>" trong danh sách (0 nếu không có). */
function soLonNhat(ids: readonly string[]): number {
  let m = 0;
  for (const id of ids) { const x = /^n(\d{1,8})$/.exec(id); if (x) m = Math.max(m, Number(x[1])); }
  return m;
}
/**
 * Cấp mã cho một danh sách nút: mã HỢP LỆ và chưa gặp thì GIỮ; thiếu / không phải chữ / sai dạng / trùng (nút sau) thì cấp `n<ke>` với ke bắt đầu từ
 * max(nutKe hợp lệ, 1 + số lớn nhất của mã n<số> đang giữ) và tăng dần (bỏ qua số trùng). Trả mã theo thứ tự đầu vào + bộ đếm mới (số kế tiếp).
 */
export function capIdNut(vao: readonly unknown[], nutKe?: unknown): { ids: string[]; ke: number } {
  const giu = new Set<string>();
  const hopLe = vao.map((v) => { if (typeof v === "string" && ID_NUT.test(v) && !giu.has(v)) { giu.add(v); return v; } return null; });
  let ke = Math.max(soKeHopLe(nutKe) ? nutKe : 1, soLonNhat([...giu]) + 1);
  const ids = hopLe.map((v) => {
    if (v !== null) return v;
    while (giu.has(`n${ke}`)) ke++;
    const id = `n${ke++}`;
    giu.add(id);
    return id;
  });
  return { ids, ke };
}
/** Bộ đếm hiện tại của một sơ đồ = max(nutKe hợp lệ, 1 + số lớn nhất của mã n<số>). */
export const nutKeCua = (sd: Pick<SoDo, "nut" | "nutKe">): number => Math.max(soKeHopLe(sd.nutKe) ? sd.nutKe : 1, soLonNhat((sd.nut ?? []).map((n) => n.id)) + 1);
/** Ghi / bỏ `nutKe` trên sơ đồ: chỉ ghi khi bộ đếm lớn hơn 1 + số lớn nhất đang có (tức có mã đã xoá cần nhớ). */
export function datNutKe<T extends Pick<SoDo, "nut" | "nutKe">>(sd: T, ke: number): T {
  const { nutKe: _cu, ...con } = sd;
  const toiThieu = soLonNhat(sd.nut.map((n) => n.id)) + 1;
  return (ke > toiThieu && soKeHopLe(ke) ? { ...con, nutKe: ke } : con) as T;
}

/** Danh sách nút sau một thao tác: giữ mã hợp lệ, cấp mã cho nút thiếu / trùng (từ bộ đếm của sơ đồ TRƯỚC thao tác), ghi lại nutKe khi cần. */
function giuId(sd: SoDo, nut: NutSoDo[], keTruoc: number = nutKeCua(sd)): SoDo {
  const { ids, ke } = capIdNut(nut.map((n) => n.id), keTruoc);
  const moi = nut.map((n, i) => ({ id: ids[i]!, thaoTac: n.thaoTac, thamSo: { ...n.thamSo }, ...(n.tuDuyet === true ? { tuDuyet: true } : {}), ...(typeof n.nenTang === "string" ? { nenTang: n.nenTang } : {}), ...(typeof n.nhuong === "boolean" ? { nhuong: n.nhuong } : {}), ...(typeof n.danhCho === "string" && n.danhCho ? { danhCho: n.danhCho } : {}), ...(n.tanSuat ? { tanSuat: { ...n.tanSuat } } : {}) }));
  return datNutKe({ ...sd, nut: moi }, ke);
}
/** Bỏ các cạnh chạm nút đã xoá; nút giữa (có cả vào lẫn ra) → nối lại nút trước với nút sau. Không có `canh` → không đụng. */
function canhSauXoa(canh: readonly CanhSoDo[] | undefined, nutId: string): CanhSoDo[] | undefined {
  if (!canh) return undefined;
  const vao = canh.find((c) => c.den === nutId && c.tu !== nutId);
  const ra = canh.find((c) => c.tu === nutId && c.den !== nutId);
  const con = canh.filter((c) => c.tu !== nutId && c.den !== nutId).map((c) => ({ tu: c.tu, den: c.den }));
  return vao && ra && vao.tu !== ra.den ? [...con, { tu: vao.tu, den: ra.den }] : con;
}

/** `id` (tuỳ chọn): khôi phục một nút đã xoá (Hoàn tác) — giữ ĐÚNG mã cũ nếu hợp lệ và chưa có nút nào dùng; không thì cấp mã mới. Nhân bản KHÔNG truyền id. */
export function themNut(sd: SoDo, thaoTac: string, thamSo: Record<string, string> = {}, viTri?: number, id?: string): SoDo {
  const nut = sd.nut.map((n) => ({ ...n, thamSo: { ...n.thamSo } }));
  const moi: NutSoDo = { id: id !== undefined && ID_NUT.test(id) && !nut.some((n) => n.id === id) ? id : "", thaoTac, thamSo: { ...thamSo } };
  const i = viTri === undefined ? nut.length : Math.max(0, Math.min(nut.length, Math.trunc(viTri)));
  nut.splice(i, 0, moi);
  return giuId(sd, nut);
}

export function xoaNut(sd: SoDo, nutId: string): SoDo {
  if (!sd.nut.some((n) => n.id === nutId)) return giuId(sd, sd.nut);
  const canh = canhSauXoa(sd.canh, nutId);
  const { canh: _c, lap: _l, ...goc } = sd;
  const lap = sd.lap?.filter((c) => c.tu !== nutId && c.den !== nutId); // vòng lặp chạm ô bị xoá thì bỏ vòng
  return giuId({ ...goc, ...(canh ? { canh } : {}), ...(lap?.length ? { lap } : {}) }, sd.nut.filter((n) => n.id !== nutId), nutKeCua(sd));
}

// buoc < 0: lên trên, > 0: xuống dưới (kẹp trong danh sách).
export function diChuyenNut(sd: SoDo, nutId: string, buoc: number): SoDo {
  const nut = sd.nut.map((n) => ({ ...n, thamSo: { ...n.thamSo } }));
  const i = nut.findIndex((n) => n.id === nutId);
  if (i < 0) return giuId(sd, nut);
  const j = Math.max(0, Math.min(nut.length - 1, i + Math.trunc(buoc)));
  const [x] = nut.splice(i, 1);
  nut.splice(j, 0, x!);
  return giuId(sd, nut);
}

export function doiThamSoNut(sd: SoDo, nutId: string, ten: string, giaTri: string): SoDo {
  return giuId(sd, sd.nut.map((n) => (n.id === nutId ? { ...n, thamSo: { ...n.thamSo, [ten]: giaTri } } : n)));
}
/** Đổi NHIỀU tham số của một bước trong MỘT thao tác (06/10/2026: từ khoá + cấu hình của nó, hoặc hai ô "chờ từ–đến" phải đổi cùng lúc — đổi lần lượt thì lần lưu giữa chừng bị máy chủ từ chối). */
export function doiNhieuThamSoNut(sd: SoDo, nutId: string, doi: Record<string, string>): SoDo {
  return giuId(sd, sd.nut.map((n) => (n.id === nutId ? { ...n, thamSo: { ...n.thamSo, ...doi } } : n)));
}

// ---- Tự duyệt cấp bước (03/10/2026): bật = tuDuyet: true; tắt = bỏ hẳn khoá (bản chạy được trùng khít lúc chưa bật) ----
export function datTuDuyet(sd: SoDo, nutId: string, bat: boolean): SoDo {
  return datTuDuyetTatCa(sd, [nutId], bat);
}
/** Sơ đồ MỚI (AI viết lại khi "Sửa bằng lời" / AI tự sửa) giữ công tắc tự động của sơ đồ CŨ: khớp theo thao tác + lần xuất hiện thứ mấy của
 *  thao tác đó (không theo vị trí). Bước mới AI thêm → theo mặc định của nơi tạo (rủi ro cao: bật sẵn tự động); bước AI bỏ → thôi. (Bước rủi ro thấp bị chuẩn hoá bỏ cờ khi lưu.) */
export function giuTuDuyet(cu: SoDo, moi: SoDo): SoDo {
  const khoa = (nut: NutSoDo[]): string[] => { const dem = new Map<string, number>(); return nut.map((n) => { const k = (dem.get(n.thaoTac) ?? 0) + 1; dem.set(n.thaoTac, k); return `${n.thaoTac}#${k}`; }); };
  const kc = khoa(cu.nut);
  const bat = new Set(cu.nut.map((n, i) => (n.tuDuyet ? kc[i]! : "")).filter(Boolean));
  const coCu = new Set(kc);
  const km = khoa(moi.nut);
  // (09/10/2026) bước MỚI (không khớp bước cũ nào) giữ cờ mặc định do nơi tạo đặt (AI dựng: rủi ro cao → bật sẵn); bước khớp bước cũ theo đúng công tắc của bước cũ.
  return giuId(moi, moi.nut.map((n, i) => { if (!coCu.has(km[i]!)) return n; const { tuDuyet: _t, ...x } = n; return bat.has(km[i]!) ? { ...x, tuDuyet: true } : x; }));
}
export function datTuDuyetTatCa(sd: SoDo, nutIds: string[], bat: boolean): SoDo {
  return giuId(sd, sd.nut.map((n) => { if (!nutIds.includes(n.id)) return n; const { tuDuyet: _b, ...x } = n; return bat ? { ...x, tuDuyet: true } : x; }));
}

// ---- Kéo-thả + chèn ở bất kỳ vị trí (trang Kịch bản, 03/10/2026) ----
/** Số bước tối đa của một sơ đồ — so-do.ts (GIOI_HAN_SO_DO.nut, máy chủ kiểm) dùng CHÍNH hằng này; trang dùng để khoá nút thêm/chèn. */
export const SO_NUT_TOI_DA = 20;
export const conChoThem = (sd: Pick<SoDo, "nut">): boolean => sd.nut.length < SO_NUT_TOI_DA;

/** Đưa nút tới vị trí `viTri` (0 = đầu) trong danh sách MỚI; vị trí ngoài khoảng bị kẹp, NaN / nút lạ → giữ nguyên thứ tự. */
export function diChuyenNutToi(sd: SoDo, nutId: string, viTri: number): SoDo {
  const nut = sd.nut.map((n) => ({ ...n, thamSo: { ...n.thamSo } }));
  const i = nut.findIndex((n) => n.id === nutId);
  if (i < 0 || Number.isNaN(viTri)) return giuId(sd, nut);
  const j = Math.max(0, Math.min(nut.length - 1, Math.trunc(viTri)));
  const [x] = nut.splice(i, 1);
  nut.splice(j, 0, x!);
  return giuId(sd, nut);
}

/** Kéo bước đang ở `tu` (0-based) rồi thả vào KHE `khe` (0 = trước bước đầu … soNut = sau bước cuối) → vị trí mới của bước;
 *  null = không đổi chỗ (thả vào khe ngay trên/dưới chính nó) hoặc số không hợp lệ — trang không gửi gì. */
export function viTriSauKhiTha(tu: number, khe: number, soNut: number): number | null {
  if (![tu, khe, soNut].every(Number.isInteger) || tu < 0 || tu >= soNut || khe < 0 || khe > soNut) return null;
  if (khe === tu || khe === tu + 1) return null;
  return khe > tu ? khe - 1 : khe;
}

/** Bố cục nhiều cột THEO THỨ TỰ CỘT: cột trái = ceil(n/2) bước đầu, cột phải = phần còn lại (không có cột rỗng). [batDau, ketThuc). */
export function chiaCot(soNut: number, soCot: 1 | 2): { batDau: number; ketThuc: number }[] {
  const n = Math.max(0, Math.trunc(soNut));
  if (soCot === 1 || n < 2) return [{ batDau: 0, ketThuc: n }];
  const m = Math.ceil(n / 2);
  return [{ batDau: 0, ketThuc: m }, { batDau: m, ketThuc: n }];
}

/** Số màu trong bảng màu bước (token CSS --buoc-1..--buoc-10 ở server/src/web/style.css). */
export const SO_MAU_BUOC = 10;
/** Màu (1..SO_MAU_BUOC) của bước thứ `soThuTu` (đếm từ 1) — theo THỨ TỰ trên màn hình, xoay vòng; hai bước kề nhau luôn khác màu.
 *  Giá trị không hợp lệ (≤ 0, NaN, ±∞) → màu 1; số lẻ → bỏ phần lẻ. */
export function mauBuoc(soThuTu: number): number {
  if (!Number.isFinite(soThuTu) || soThuTu < 1) return 1;
  return ((Math.trunc(soThuTu) - 1) % SO_MAU_BUOC) + 1;
}

/** Cột chứa toạ độ ngang `x` (mép trái/phải tính vào cột); ngoài mọi cột → cột gần nhất. Không có cột / x không phải số → null. */
export function cotGanNhat(cot: { trai: number; phai: number }[], x: number): number | null {
  if (!cot.length || Number.isNaN(x)) return null;
  let tot = 0, kc = Infinity;
  cot.forEach((c, i) => { const d = x < c.trai ? c.trai - x : x > c.phai ? x - c.phai : 0; if (d < kc) { kc = d; tot = i; } });
  return tot;
}

/** Khe ứng với toạ độ dọc `y` của con trỏ: số thẻ có tâm dọc NẰM TRÊN `y` (tâm theo thứ tự hiển thị). y không phải số → null. */
export function kheTheoToaDo(tamDoc: number[], y: number): number | null {
  if (Number.isNaN(y)) return null;
  return tamDoc.filter((t) => t < y).length;
}

// =====================================================================================================================================
// TRẢI NGHIỆM SỬA SƠ ĐỒ (04/10/2026, docs/phan-tich-ux-so-do.md — người dùng chọn bố cục B + nhóm a–e). Hàm thuần cho trang Kịch bản:
// nhóm/tìm thao tác của bảng "+", vị trí bảng nổi, cuộn tối thiểu, bản nháp có uid (bước giữ danh tính qua mọi lần đánh lại n1…nk),
// hàng đợi lưu lạc quan + tuần tự, đổi số bước trong câu lỗi sang số TRÊN MÀN HÌNH, kiểm ô tham số của bảng thêm bước.
// =====================================================================================================================================

// Lời một thao tác với tham số cụ thể (mẫu "{ten_tham_so}", đoạn "[ … ]" chỉ hiện khi mọi tham số trong đó có giá trị). Giữ nguyên chữ (web
// dựng bằng textContent nên ký tự đặc biệt không thành HTML). ban-do.ts xuất lại hàm này (trước 04/10 định nghĩa ở đó).
export function moTaThaoTac(t: { mauMoTa: string }, thamSo: Record<string, string | undefined>): string {
  // Từ khoá nhiều dòng lưu "|" dạng %7C (06/10/2026) — hiện lời bằng chữ thật.
  const gt = (k: string) => (THAM_SO_XOAY.has(k) ? giaiMaTuKhoa((thamSo[k] ?? "").trim()) : (thamSo[k] ?? "").trim());
  // "[!ten …]" (04/10/2026): đoạn chỉ hiện khi tham số `ten` RỖNG (vd. địa chỉ nhóm để trống → bot tự chọn nhóm).
  const tuyChon = t.mauMoTa.replace(/\[!([a-z_]+)([^\]]*)\]/g, (_m, ten: string, doan: string) => (gt(ten) ? "" : doan)).replace(/\[([^\]]*)\]/g, (_m, doan: string) => {
    const bien = [...doan.matchAll(/\{([a-z_]+)\}/g)].map((m) => m[1]!);
    return bien.every((b) => gt(b)) ? doan : "";
  });
  // trim: đoạn tuỳ chọn ĐẦU câu ("[!bai_url Tự tìm…]" — địa chỉ để trống, 05/10/2026) không để lại dấu cách đầu dòng.
  // {@video:<mạng>} (06/10/2026, bước Đăng video): dòng tóm tắt tiếng Việt thường dựng từ tham số cau_hinh_video.
  return tuyChon.replace(/\{@video:([a-z]+)\}/g, (_m, nt: string) => (laNenTangVideo(nt) ? tomTatDangVideo(nt, thamSo.cau_hinh_video ?? "") : "Đăng video")).replace(/\{([a-z_]+)\}/g, (_m, k: string) => gt(k) || "(chưa điền)").trim()
    // L-102: khoảng nghỉ từ = đến không còn “ngẫu nhiên” gì — "Nghỉ ngẫu nhiên 180–180 giây" → "Nghỉ 180 giây".
    .replace(/^Nghỉ ngẫu nhiên (\d+)–(\d+) giây/, (m, a: string, b: string) => (a === b ? `Nghỉ ${a} giây` : m));
}

// ---- nhóm thao tác (bảng "+" chia theo loại; thẻ bước có màu theo loại) ----
export type LoaiThaoTac = "tim" | "luot" | "tuong_tac" | "dang" | "nghi";
/** Loại theo MÃ thao tác (giống nhau giữa các mạng): tìm/xem/đọc, lướt, đăng bài, nghỉ; còn lại = tương tác (bình luận, thích, trả lời…). */
export function loaiThaoTac(ma: string): LoaiThaoTac {
  if (ma === "nghi") return "nghi";
  if (/^luot_/.test(ma)) return "luot";
  if (/^(?:tim_(?!roi_|ghim_)|xem_|doc_)/.test(ma)) return "tim"; // tim_ghim_binh_luan (07/10/2026: thả tim / ghim bình luận) là tương tác
  if (/^dang_(?:bai|video)/.test(ma)) return "dang";
  return "tuong_tac";
}
const NHOM: { ma: string; ten: string; loai: LoaiThaoTac[] }[] = [
  { ma: "tim-doc", ten: "Tìm & đọc", loai: ["tim", "luot"] },
  { ma: "tuong-tac", ten: "Tương tác", loai: ["tuong_tac"] },
  { ma: "dang", ten: "Đăng", loai: ["dang"] },
  { ma: "khac", ten: "Khác", loai: ["nghi"] },
];
/** Chia thao tác theo nhóm cố định (Tìm & đọc → Tương tác → Đăng → Khác), giữ thứ tự gốc trong nhóm, bỏ nhóm rỗng. */
export function nhomThaoTac<T extends { ma: string }>(ds: T[]): { ma: string; ten: string; ds: T[] }[] {
  return NHOM.map((g) => ({ ma: g.ma, ten: g.ten, ds: ds.filter((t) => g.loai.includes(loaiThaoTac(t.ma))) })).filter((g) => g.ds.length);
}

/** Chữ thường, bỏ dấu tiếng Việt (đ → d) — để gõ "nghi" / "tra loi" vẫn tìm ra "Nghỉ" / "Trả lời". */
export function boDau(s: string): string {
  return s.normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D").toLowerCase();
}
/** Lọc thao tác theo ô tìm: mọi từ gõ (không dấu) phải có trong tên ngắn hoặc mã thao tác. Ô trống → tất cả. */
export function locThaoTac<T extends { ma: string; tenNgan: string }>(ds: T[], q: string): T[] {
  const tu = boDau(q).split(/\s+/).filter(Boolean);
  if (!tu.length) return ds;
  return ds.filter((t) => { const chu = boDau(`${t.tenNgan} ${t.ma.replace(/_/g, " ")}`); return tu.every((x) => chu.includes(x)); });
}

// ---- vị trí bảng nổi + cuộn ----
export interface HopNeo { trai: number; tren: number; rong: number; cao: number }
export type ViTriPop = { kieu: "sheet" } | { kieu: "noi"; huong: "duoi" | "tren"; trai: number; tren: number; caoToiDa: number };
/**
 * Bảng chọn thao tác mở NGAY TẠI nút "+" (toạ độ khung nhìn). Đủ chỗ dưới → dưới nút; thiếu → lật lên; thiếu cả hai → phía rộng hơn với
 * cao tối đa = chỗ còn (danh sách cuộn trong bảng, nút Thêm luôn thấy). Màn ≤ `sheetToiDa` px → bảng trượt từ dưới lên. Không bao giờ
 * cuộn trang. mepTren = thanh trên dính (56 px), le = lề khung, khe = khoảng cách tới nút.
 */
export function viTriPopover(neo: HopNeo, rongPop: number, caoCan: number, khung: { rong: number; cao: number },
  o: { mepTren?: number; mepDuoi?: number; khe?: number; le?: number; sheetToiDa?: number } = {}): ViTriPop {
  const { mepTren = 56, mepDuoi = 0, khe = 8, le = 8, sheetToiDa = 640 } = o;
  if (khung.rong <= sheetToiDa) return { kieu: "sheet" };
  const choDuoi = khung.cao - mepDuoi - le - (neo.tren + neo.cao + khe);
  const choTren = neo.tren - khe - (mepTren + le);
  const huong: "duoi" | "tren" = caoCan <= choDuoi ? "duoi" : caoCan <= choTren ? "tren" : choDuoi >= choTren ? "duoi" : "tren";
  const caoToiDa = Math.max(0, huong === "duoi" ? choDuoi : choTren);
  const trai = Math.max(le, Math.min(neo.trai, khung.rong - le - rongPop));
  const tren = huong === "duoi" ? neo.tren + neo.cao + khe : neo.tren - khe - Math.min(caoCan, caoToiDa);
  return { kieu: "noi", huong, trai, tren, caoToiDa };
}
/** Số px cần cuộn (âm = lên) để hộp [tren, duoi] (toạ độ khung nhìn) vào hẳn khung nhìn, chừa 12 px; đã thấy → 0. Hộp cao hơn khung
 *  → giữ đầu hộp thấy được. mepTren/mepDuoi = thanh dính trên/dưới che mép. */
export function cuonToiThieu(hop: { tren: number; duoi: number }, khungCao: number, mepTren = 0, mepDuoi = 0): number {
  if (!Number.isFinite(hop.tren) || !Number.isFinite(hop.duoi) || !Number.isFinite(khungCao)) return 0;
  const CHUA = 12;
  if (hop.tren < mepTren) return hop.tren - mepTren - CHUA;
  const day = khungCao - mepDuoi;
  if (hop.duoi > day) return Math.max(0, Math.min(hop.duoi - day + CHUA, hop.tren - mepTren - CHUA));
  return 0;
}

// ---- bản nháp có uid: mỗi bước mang một số định danh của TRANG (không gửi máy chủ), đi theo bước qua mọi lần di chuyển/đánh lại id ----
export interface BanNhap { sd: SoDo; uid: number[] } // uid[i] ↔ sd.nut[i]
export function bnTuSoDo(sd: SoDo, capUid: () => number): BanNhap {
  return { sd, uid: sd.nut.map(() => capUid()) };
}
const viTriUid = (b: BanNhap, uid: number): number => b.uid.indexOf(uid);
/** Đưa bước `uid` tới vị trí `viTri` (kẹp trong khoảng). null = uid lạ / NaN / không đổi chỗ. */
export function bnDiChuyen(b: BanNhap, uid: number, viTri: number): BanNhap | null {
  const i = viTriUid(b, uid);
  if (i < 0 || Number.isNaN(viTri)) return null;
  const j = Math.max(0, Math.min(b.uid.length - 1, Math.trunc(viTri)));
  if (j === i) return null;
  const uid2 = b.uid.slice();
  const [x] = uid2.splice(i, 1);
  uid2.splice(j, 0, x!);
  return { sd: diChuyenNutToi(b.sd, b.sd.nut[i]!.id, j), uid: uid2 };
}
export function bnXoa(b: BanNhap, uid: number): BanNhap | null {
  const i = viTriUid(b, uid);
  if (i < 0) return null;
  return { sd: xoaNut(b.sd, b.sd.nut[i]!.id), uid: b.uid.filter((u) => u !== uid) };
}
/** (13/10/2026) MẶC ĐỊNH của bước MỚI THÊM: rủi ro cao → "Tự động" (tuDuyet), như canvas và AI viết. Mọi nơi gọi bnThem cho bước mới phải truyền giá trị này. */
export const tuDongMacDinh = (ruiRo: string | undefined): boolean => ruiRo === "cao";
/** Chèn một bước (thao tác + tham số [+ tự động]) vào vị trí `viTri` (kẹp); đủ 20 bước → null. */
export function bnThem(b: BanNhap, viTri: number, nut: { thaoTac: string; thamSo: Record<string, string>; tuDuyet?: boolean; id?: string }, uidMoi: number): BanNhap | null {
  if (!conChoThem(b.sd) || Number.isNaN(viTri)) return null;
  const i = Math.max(0, Math.min(b.uid.length, Math.trunc(viTri)));
  const sd = themNut(b.sd, nut.thaoTac, nut.thamSo, i, nut.id);
  const sd2 = nut.tuDuyet ? datTuDuyet(sd, sd.nut[i]!.id, true) : sd;
  const uid = b.uid.slice();
  uid.splice(i, 0, uidMoi);
  return { sd: sd2, uid };
}
export function bnDoiThamSo(b: BanNhap, uid: number, ten: string, giaTri: string): BanNhap | null {
  const i = viTriUid(b, uid);
  return i < 0 ? null : { sd: doiThamSoNut(b.sd, b.sd.nut[i]!.id, ten, giaTri), uid: b.uid };
}
export function bnDoiNhieuThamSo(b: BanNhap, uid: number, doi: Record<string, string>): BanNhap | null {
  const i = viTriUid(b, uid);
  return i < 0 ? null : { sd: doiNhieuThamSoNut(b.sd, b.sd.nut[i]!.id, doi), uid: b.uid };
}
export function bnTuDuyet(b: BanNhap, uids: number[], bat: boolean): BanNhap | null {
  const ids = uids.map((u) => viTriUid(b, u)).filter((i) => i >= 0).map((i) => b.sd.nut[i]!.id);
  return ids.length ? { sd: datTuDuyetTatCa(b.sd, ids, bat), uid: b.uid } : null;
}

/** Vị trí TRÊN MÀN HÌNH (0-based) của từng bước trong dãy thử: theo uid; bước không có trên màn hình (mới chèn/nhân bản) → null. */
export function gocTheoUid(uidThu: number[], uidManHinh: number[]): (number | null)[] {
  return uidThu.map((u) => { const i = uidManHinh.indexOf(u); return i < 0 ? null : i; });
}
/**
 * Câu lỗi máy chủ/luật đánh số theo sơ đồ ĐANG THỬ ("Bước 6 (Nghỉ) đứng cuối…") → đổi sang số người dùng đang THẤY (vấn đề V7: trước đây
 * "Bước 1 (Trả lời…)" trong khi trên màn hình bước 1 vẫn là "Tìm bài"). goc[i] = vị trí trên màn hình của bước thứ i+1 trong dãy thử.
 * Bước chưa có trên màn hình (chèn mới) giữ số vị trí định chèn; nếu số đó trùng một bước khác được nhắc trong cùng câu → "bước mới".
 * Số ngoài khoảng / chữ khác giữ nguyên.
 */
export function doiSoBuocTrongLoi(loi: string, goc: (number | null)[]): string {
  const RE = /(Bước|bước) (\d+)/g;
  const soManHinh = new Set<number>();
  for (const m of loi.matchAll(RE)) { const g = goc[Number(m[2]) - 1]; if (g !== null && g !== undefined) soManHinh.add(g + 1); }
  return loi.replace(RE, (cu, chu: string, so: string) => {
    const i = Number(so) - 1;
    if (i < 0 || i >= goc.length) return cu;
    const g = goc[i];
    if (g === null || g === undefined) return soManHinh.has(i + 1) ? `${chu} mới` : cu;
    return `${chu} ${g + 1}`;
  });
}

// ---- hàng đợi lưu: lạc quan + tuần tự ----
export type KetQuaGui = { ok: true; sd: SoDo } | { ok: false; loi: unknown; xungDot?: boolean };
export interface NguCanhLoi { thu: BanNhap; truoc: BanNhap; manHinh: BanNhap; xungDot: boolean }
export interface ViecSua {
  /** Áp thao tác lên một bản nháp (dựng lại trên bản MỚI NHẤT mỗi lần cần); null = không còn áp được (bỏ qua, không gửi). */
  lam: (b: BanNhap) => BanNhap | null;
  xong?: (b: BanNhap) => void;
  loi?: (e: unknown, c: NguCanhLoi) => void;
}
/**
 * Hàng đợi lưu sơ đồ của trang (04/10/2026): mỗi thao tác hiện NGAY trên màn hình (hienThi = các thao tác đang chờ áp lên bản đã lưu),
 * gửi máy chủ TỪNG CÁI MỘT trên bản đã lưu mới nhất (phiên bản đúng → không 409 giả như lỗi R2 cũ). Máy chủ từ chối một thao tác → chỉ
 * thao tác đó bị hoàn, các thao tác sau dựng lại trên bản đã lưu; 409 (nơi khác vừa đổi) → bỏ hết hàng đợi. `gui` do trang cấp (PUT).
 */
export class HangDoiSua {
  private xn: BanNhap;
  private cho: ViecSua[] = [];
  private chay: Promise<void> | null = null;
  constructor(xacNhan: BanNhap, private readonly gui: (sd: SoDo) => Promise<KetQuaGui>, private readonly capUid: () => number, private readonly khiDoi: () => void = () => {}) {
    this.xn = xacNhan;
  }
  get xacNhan(): BanNhap { return this.xn; }
  get ban(): boolean { return this.cho.length > 0; }
  get soCho(): number { return this.cho.length; }
  /** Bản đang hiện: áp lần lượt các thao tác đang chờ lên bản đã lưu (thao tác không còn áp được thì bỏ qua). */
  hienThi(): BanNhap {
    let b = this.xn;
    for (const v of this.cho) b = v.lam(b) ?? b;
    return b;
  }
  /** Xếp một thao tác. Trả bản hiện mới; null = không áp được lên bản đang hiện (không xếp, không gửi). */
  them(v: ViecSua): BanNhap | null {
    const moi = v.lam(this.hienThi());
    if (!moi) return null;
    this.cho.push(v);
    if (!this.chay) this.chay = this.vong().finally(() => { this.chay = null; });
    return moi;
  }
  async choXong(): Promise<void> { while (this.chay) await this.chay; }
  /** Bản mới từ máy chủ (tải lại / AI sửa) khi hàng đợi rảnh: cùng dãy thao tác → giữ uid (menu, tiêu điểm đi theo bước), khác → uid mới. */
  datXacNhan(sd: SoDo): void {
    const cung = sd.nut.length === this.xn.sd.nut.length && sd.nut.every((n, i) => n.thaoTac === this.xn.sd.nut[i]!.thaoTac);
    this.xn = { sd, uid: cung ? this.xn.uid.slice() : sd.nut.map(() => this.capUid()) };
  }
  private async vong(): Promise<void> {
    while (this.cho.length) {
      const v = this.cho[0]!;
      const truoc = this.xn;
      const thu = v.lam(truoc);
      if (!thu) { this.cho.shift(); this.khiDoi(); continue; }
      let kq: KetQuaGui;
      try { kq = await this.gui(thu.sd); } catch (e) { kq = { ok: false, loi: e }; }
      this.cho.shift();
      if (kq.ok) {
        this.xn = { sd: kq.sd, uid: kq.sd.nut.length === thu.uid.length ? thu.uid : kq.sd.nut.map(() => this.capUid()) };
        try { v.xong?.(this.xn); } finally { this.khiDoi(); }
        continue;
      }
      const xungDot = !!kq.xungDot;
      if (xungDot) this.cho = [];
      try { v.loi?.(kq.loi, { thu, truoc, manHinh: this.hienThi(), xungDot }); } finally { this.khiDoi(); }
    }
  }
}

// ---- kiểm ô tham số của bảng thêm bước (trước khi gửi; máy chủ vẫn kiểm lại đủ luật) ----
export interface ThamSoKiem { ten: string; kieu: "chuoi" | "so"; batBuoc?: boolean; min?: number; max?: number; luaChon?: string[] }
/** Lỗi theo TỪNG Ô: bắt buộc để trống, ô số không phải số nguyên, ngoài TRẦN KỸ THUẬT, ô chọn (luaChon) ngoài danh sách. Rỗng = điền đúng.
 * (05/10/2026) min/max của khối là KHUYẾN NGHỊ — vượt khuyến nghị KHÔNG phải lỗi (trang hiện lời khuyên, khuyen-nghi-so.ts).
 * (07/10/2026, Giai đoạn 0 · pha B) `choPhepTrong`: CHẾ ĐỘ MỀM của trang — ô bắt buộc để TRỐNG vẫn cho thêm (bước hiện thẻ ĐỎ "Thiếu đầu vào", xem thieuThamSoCua);
 * mọi lỗi CỨNG (chữ vào ô số, ngoài trần kỹ thuật, ngoài danh sách chọn, từ khoá / chờ giữa các lần sai định dạng) VẪN chặn. Mặc định (không tuỳ chọn) = như cũ. */
export function kiemThamSoThem(defs: ThamSoKiem[], gt: Record<string, string | undefined>, opts: { choPhepTrong?: boolean } = {}): Record<string, string> {
  const loi: Record<string, string> = {};
  for (const d of defs) {
    const v = (gt[d.ten] ?? "").trim();
    // Ô TỪ KHOÁ (THAM_SO_XOAY) để trống VẪN bị chặn tại ô ngay cả ở chế độ mềm: test cũ TK7 (boss-kich-ban-tu-khoa) khoá hành vi này và chưa nằm trong danh sách được duyệt đổi — chờ người dùng quyết.
    if (!v) { if (d.batBuoc && (!opts.choPhepTrong || THAM_SO_XOAY.has(d.ten))) loi[d.ten] = "Bắt buộc — hãy điền"; continue; }
    if (d.luaChon && !d.luaChon.includes(v)) { loi[d.ten] = `Chỉ nhận: ${d.luaChon.join(" / ")}`; continue; }
    // F-1: ô từ khoá TÌM nhận nhiều từ khoá `a | b | c` — kiểm số từ / độ dài / phần rỗng ngay ở bảng thêm bước (máy chủ kiểm lại lúc lưu).
    if (d.kieu !== "so" && THAM_SO_XOAY.has(d.ten)) { const lx = loiDanhSachTuKhoa(v); if (lx) { loi[d.ten] = lx.charAt(0).toUpperCase() + lx.slice(1); continue; } }
    if (d.kieu !== "so") continue;
    if (!/^-?\d+$/.test(v)) { loi[d.ten] = "Phải là số nguyên"; continue; }
    const ngoai = loiNgoaiTran(d, Number(v));
    if (ngoai) loi[d.ten] = ngoai.charAt(0).toUpperCase() + ngoai.slice(1);
  }
  // (06/10/2026) Chờ giữa các lần: cả hai ô hoặc không ô nào, từ ≤ đến (lỗi theo ô chưa có lỗi riêng).
  if (defs.some((d) => d.ten === TS_CHO_TU) && !loi[TS_CHO_TU] && !loi[TS_CHO_DEN]) {
    const l = loiChoGiuaTs(gt);
    if (l) loi[(gt[TS_CHO_TU] ?? "").trim() ? TS_CHO_DEN : TS_CHO_TU] = l;
  }
  // (06/10/2026) cấu hình nhiều từ khoá: đúng định dạng, không nhiều cặp hơn số từ khoá.
  const cfg = defs.some((d) => d.ten === "tu_khoa_cau_hinh") ? (gt.tu_khoa_cau_hinh ?? "").trim() : "";
  if (cfg && !loi.tu_khoa_cau_hinh && !loi.tu_khoa) {
    const l = loiCauHinhTuKhoa(cfg, Math.max(1, tachTuKhoa(gt.tu_khoa).length));
    if (l) loi.tu_khoa_cau_hinh = l.charAt(0).toUpperCase() + l.slice(1);
  }
  return loi;
}

// ---- (07/10/2026, Giai đoạn 0 · pha B) ô THIẾU của một bước = thẻ ĐỎ — bản của TRANG, đúng chữ + đúng luật với chuanHoaSoDo({ mem: true }) (so-do.ts, có test đối chiếu) ----
export interface ThamSoThieuDef { ten: string; nhan: string; moTa: string; batBuoc?: boolean; macDinh?: string }
export interface OThieu { ma: "thieu_tham_so" | "thieu_dia_chi"; ten: string; nhan: string; lyDo: string }
// Sao y so-do.ts (THAM_SO_MOT_DICH / DUONG_TRANG_CHU / laTrangChu — L-73): tệp này phải nhẹ (trang web đóng gói, không kéo thư viện khối/YAML/zod); đối chiếu bằng test.
const THAM_SO_MOT_DICH_TRANG = new Set(["bai_url", "video_url"]);
const DUONG_TRANG_CHU_TRANG = new Set(["", "/", "/home", "/foryou", "/following", "/feed", "/explore", "/trending", "/watch", "/feed/subscriptions"]);
function laTrangChuTrang(v: string): boolean {
  try { const u = new URL(v); return DUONG_TRANG_CHU_TRANG.has(u.pathname.replace(/\/+$/, "").toLowerCase()) && !u.searchParams.has("v"); } catch { return false; }
}
/** Các ô của một bước đang THIẾU (ô bắt buộc để trống → "thieu_tham_so"; ô địa chỉ MỘT bài/video để trống mà mặc định là TRANG CHỦ → "thieu_dia_chi"), theo thứ tự ô. Rỗng = đủ. */
export function thieuThamSoCua(defs: readonly ThamSoThieuDef[], gt: Record<string, string | undefined>): OThieu[] {
  const ra: OThieu[] = [];
  for (const d of defs) {
    if (String(gt[d.ten] ?? "").trim()) continue;
    if (d.batBuoc) ra.push({ ma: "thieu_tham_so", ten: d.ten, nhan: d.nhan, lyDo: `thiếu “${d.nhan}” (${d.moTa})` });
    else if (THAM_SO_MOT_DICH_TRANG.has(d.ten) && d.macDinh && laTrangChuTrang(d.macDinh)) ra.push({ ma: "thieu_dia_chi", ten: d.ten, nhan: d.nhan, lyDo: `thiếu “${d.nhan}” — cần địa chỉ MỘT bài/video cụ thể người dùng đưa (bỏ trống sẽ mở trang chủ)` });
  }
  return ra;
}
